import { lazy, StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom'
import App from './App'
import { ehCardapio } from './rotas'
import './styles/style.css'

// Login, cadastro e painel vem em arquivo separado: o site e a porta de
// entrada de quem nao conhece a Skyenex e nao deve pagar por esse codigo.
const AuthRoutes = lazy(() => import('./auth/AuthRoutes'))
// O cardapio publico e outro pedaco: o cliente do restaurante nao baixa login
// nem painel, e quem entra no painel nao baixa o cardapio.
const RotasPublicas = lazy(() => import('./cardapio-publico/RotasPublicas'))
const TermoPublico = lazy(() => import('./termo/TermoPublico'))

// O CSS do login ainda nao chegou enquanto o pedaco carrega: fundo inline,
// para nao piscar o creme do site antes da tela escura. O painel no tema
// claro (data-theme do index.html) ja comeca no cinza claro dele.
const fundoCarregando = () =>
  location.pathname.startsWith('/painel') && document.documentElement.getAttribute('data-theme') === 'light' ? '#f4f5f9' : '#0b1524'
const Carregando = () => <div style={{ minHeight: '100vh', background: fundoCarregando() }} />
// O mesmo para o fundo claro do cardapio.
const carregandoCardapio = <div style={{ minHeight: '100vh', background: '#f6f5f2' }} />

/**
 * Tudo que nao e a pagina inicial. Uma rota "/:slug" no topo roubaria
 * "/login"; e o AuthRoutes debaixo de "/painel/*" perderia os caminhos
 * absolutos dele. Entao um "*" so, que escolhe pelo primeiro pedaco.
 */
function ForaDoSite() {
  const { pathname } = useLocation()
  // /termo/<token> e a pagina de assinatura; "termo" e slug reservado no backend.
  if (pathname.startsWith('/termo/')) {
    return (
      <Suspense fallback={<Carregando />}>
        <Routes>
          <Route path="/termo/:token" element={<TermoPublico />} />
        </Routes>
      </Suspense>
    )
  }
  if (ehCardapio(pathname)) {
    return (
      <Suspense fallback={carregandoCardapio}>
        <RotasPublicas />
      </Suspense>
    )
  }
  // Link digitado com maiuscula (/DeliciaCaseira) ainda chega no cardapio.
  const minusculo = pathname.toLowerCase()
  if (minusculo !== pathname && ehCardapio(minusculo)) return <Navigate to={minusculo} replace />
  return (
    <Suspense fallback={<Carregando />}>
      <AuthRoutes />
    </Suspense>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="*" element={<ForaDoSite />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
